import { createAsyncActions } from "~/utils/store";

export var LOAD_CONTAS_RECEBER = createAsyncActions("LOAD_CONTAS_RECEBER");
export var CREATE_CONTA_RECEBER = createAsyncActions("CREATE_CONTA_RECEBER");
export var UPDATE_CONTA_RECEBER = createAsyncActions("UPDATE_CONTA_RECEBER");
export var DELETE_CONTA_RECEBER = createAsyncActions("DELETE_CONTA_RECEBER");
export var MARK_AS_RECEIVED = createAsyncActions("MARK_CONTA_RECEBER_AS_RECEIVED");

export var loadContasReceber = function(filter) {
    return {
        type: LOAD_CONTAS_RECEBER.INIT,
        payload: {
            request: {
                method: "GET",
                url: "/contas-receber",
                params: filter,
            },
            filter: filter,
        },
    };
};

export var createContaReceber = function(data) {
    return {
        type: CREATE_CONTA_RECEBER.INIT,
        payload: {
            request: {
                method: "POST",
                url: "/contas-receber",
                data: data,
            },
        },
    };
};

export var updateContaReceber = function(id, data) {
    return {
        type: UPDATE_CONTA_RECEBER.INIT,
        payload: {
            request: {
                method: "PUT",
                url: "/contas-receber/" + id,
                data: data,
            },
        },
        id: id,
    };
};

export var deleteContaReceber = function(id) {
    return {
        type: DELETE_CONTA_RECEBER.INIT,
        payload: {
            request: {
                method: "DELETE",
                url: "/contas-receber/" + id,
            },
        },
        id: id,
    };
};

export var markAsReceived = function(id, paidAt) {
    return {
        type: MARK_AS_RECEIVED.INIT,
        payload: {
            request: {
                method: "PUT",
                url: "/contas-receber/" + id + "/received",
                data: { paid_at: paidAt },
            },
        },
        id: id,
    };
};
